// FollowStar — the ONE follow control (ADR-073 §6; judged at the tickets
// hub's stories, rounds 3–5): the row's leading seat, the peek's leading seat,
// the entity header's adornment — sites and tickets alike. Its own small
// button (the CopyableCode precedent — never IconButton's grey square hover),
// on the SOTA toggle law (X's like · Gmail's star): the FILL encodes ONLY the
// persisted state; hover and focus are a colour affordance (the outline warms
// to the followed colour, the filled star dims a touch), press is a
// motion-safe scale tick — never a fill preview, so a click always flips
// something visible under the pointer (the unfollow-under-cursor test). The
// order of a list re-floats at QUESTION time only, never mid-toggle (the
// caller's concern). `stopPropagation` keeps a row click from opening the peek.

import { useTranslation } from 'react-i18next';
import { icons } from '../ui/icons.js';

export interface FollowStarProps {
  followed: boolean;
  onToggle: () => void;
  /** 16 on a row; 20 in the peek's identity seat (the outline-22 optical equivalent). */
  size?: number;
  disabled?: boolean;
}

export function FollowStar({ followed, onToggle, size = 16, disabled = false }: FollowStarProps) {
  const { t } = useTranslation('common');
  return (
    <button
      type="button"
      // One accessible name, always; `aria-pressed` says whether it is on (a toggle never renames itself).
      aria-label={t('follow.on')}
      aria-pressed={followed}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={`inline-flex shrink-0 cursor-pointer items-center justify-center rounded p-1 outline-none transition focus-ring motion-safe:active:scale-90 disabled:cursor-default disabled:opacity-50 ${
        followed
          ? 'text-[var(--color-primary-display)] hover:opacity-75'
          : 'text-[var(--color-text-secondary)] hover:text-[var(--color-primary-display)] focus-visible:text-[var(--color-primary-display)]'
      }`}
    >
      <icons.favorite aria-hidden size={size} weight={followed ? 'fill' : 'regular'} />
    </button>
  );
}
